 <template>
  <section>
    <div class="box">
      <div class="box-content">
        <!-- form -->
        <validation-observer ref="form" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(createCampaign)">
            <div class="margin-top-l">
              <validation-provider
                name="nome"
                rules="required"
                v-slot="{ errors }"
              >
                <div
                  class="form-field item group-input "
                  :class="{ errors: errors[0] }"
                >
                  Nome da Campanha
                  <input
                    type="text"
                    v-model="newCampaign.name"
                    placeholder="Nome da campanha"
                  />
                  <span class="erros-alert">{{ errors[0] }}</span>
                </div>
              </validation-provider>
              <!-- type -->
              <div class="flex column">
                <div class="flex-1 p-8">
                  Tipo de Campanha
                </div>
                <div class="flex-1" style="padding: 8px">
                  <div
                    class="button secondary"
                    @click="newCampaign.campaign_type = 'EMAIL'"
                    :class="{ active: newCampaign.campaign_type === 'EMAIL' }"
                  >
                    E-MAIL
                  </div>
                  <div
                    class="button secondary"
                    @click="newCampaign.campaign_type = 'WHATSAPP'"
                    :class="{ active: newCampaign.campaign_type === 'WHATSAPP' }"
                    style="margin-left: 8px"
                  >
                    WHATSAPP
                  </div>
                  <div
                    class="button secondary"
                    @click="newCampaign.campaign_type = 'SMS'"
                    :class="{ active: newCampaign.campaign_type === 'SMS' }"
                    style="margin-left: 8px"
                  >
                    SMS
                  </div>
                </div>
              </div>

              <!-- contacts -->
              <div>
                <div class="flex p-8 margin-top-m">
                  Contatos para qual a campanha vai ser enviada:
                </div>
                <div class="flex margin-top-s">
                  <div class="flex-1">
                    <div class="form-field item group-input ">
                      Lista
                      <select class="input" v-model="newCampaign.contact_list_id">
                        <option value=""> - </option>
                        <option
                          v-for="(v, k) in listsAccount"
                          :key="k"
                          :value="v.id"
                        >
                          {{ v.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="flex-1">
                    <div class="form-field item group-input ">
                      Tag
                      <select class="input" v-model="newCampaign.contact_tag_id">
                        <option value=""> - </option>
                        <option
                          v-for="(v, k) in tagsAccount"
                          :key="k"
                          :value="v.id"
                        >
                          {{ v.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="flex-1">
                    <div class="form-field item group-input ">
                      Exclusão de Tag
                      <select class="input" v-model="newCampaign.not_contact_tag_id">
                        <option value=""> - </option>
                        <option
                          v-for="(v, k) in tagsAccount"
                          :key="k"
                          :value="v.id"
                        >
                          {{ v.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <!-- limite date -->
                <div class="flex column margin-top-m p-8">
                  (AFTER) Filtrar para apenas contatos que entraram na Lista ou Tag após esta data:
                  <div class="margin-top-s">
                    <date-picker
                      v-model="newCampaign.limite_date"
                      valueType="format"
                      type="datetime"
                      confirm="true"
                      confirm-text="FILTRAR CONTATOS"
                    >
                    </date-picker>
                  </div>
                </div>

                <!-- limite date -->
                <div class="flex column margin-top-m p-8">
                  (BEFORE) Filtrar para apenas contatos que entraram na Lista ou Tag antes desta data:
                  <div class="margin-top-s">
                    <date-picker
                      v-model="newCampaign.limite_date_before"
                      valueType="format"
                      type="datetime"
                      confirm="true"
                      confirm-text="FILTRAR CONTATOS"
                    >
                    </date-picker>
                  </div>
                </div>
                <div class="flex p-8 margin-top-s">
                  Quantidade de contatos que serão afetados:
                  <div class="contacts">
                    <b>{{ formatTotalContacts | number }}</b>
                  </div>
                </div>
              </div>

              <!-- schedulle -->
              <div class="flex column margin-top-m p-8">
                Agendar envio para: (Não selecionar data para disparo imediato)
                <div class="margin-top-s">
                  <date-picker
                    v-model="newCampaign.scheduling"
                    valueType="format"
                    type="datetime"
                    confirm="true"
                    confirm-text="AGENDAR ENVIO"
                  >
                  </date-picker>
                </div>
              </div>
            </div>

            <!-- message -->
            <!-- <div class="flex column margin-top-l p-8">
              Mensagem:
              <div class="margin-top-s">
                <textarea
                  v-model="newCampaign.message"
                  wrap="off"
                  cols="155"
                  rows="10"
                ></textarea>
              </div>
            </div> -->

            <div class="margin-top-l actions">
              <router-link :to="{ name: 'Campaign' }">
                <button class="button secondary">
                  Voltar
                </button>
              </router-link>

              <button class="button primary" type="submit">
                Criar Campanha
              </button>
            </div>
          </form>
        </validation-observer>
      </div>
    </div>
  </section>
</template>

<script>

import { 
  getContacts,
} from "@/services/contact";

import {
  createCampaign,
  getCampaign,
} from "@/services/campaign";

import {
  getTags
} from "@/services/tag";

import {
  getLists
} from "@/services/list";

export default {
  name: "campaign-new",
  components: {},
  props: ['campaign_id'],
  data() {
    return {
      newCampaign: {
        name: "",
        campaign_type: "EMAIL",
        template: "DEFAULT",
        contact_list_id: '',
        contact_tag_id: '',
        not_contact_tag_id: '',
        scheduling: null,
        limite_date: null,
        limite_date_before: null,
        status: "DRAFT",
      },
      listsAccount: [],
      tagsAccount: [],
      templateList: [],
      totalContacts: null,
    };
  },
  mounted() {
    this.getTags()
    this.getLists()

    if (this.campaign_id) {
      this.getCampaign()
    }

  },
  watch: {
    'newCampaign.contact_list_id' () {
      this.getContacts()
    },
    'newCampaign.contact_tag_id' () {
      this.getContacts()
    },
    'newCampaign.not_contact_tag_id' () {
      this.getContacts()
    },
    'newCampaign.limite_date' () {
      this.getContacts()
    },
    'newCampaign.limite_date_before' () {
      this.getContacts()
    },
  },
  computed: {
    formatTotalContacts() {
      if (this.totalContacts === null) {
        return " --- ";
      }

      return this.totalContacts;
    },
  },
  methods: {
    getCampaign() {
      getCampaign(this.campaign_id)
        .then(result => {
          this.newCampaign = result
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Falha ao buscar campanha'
          })
        })
    },
    createCampaign() {
      let params = this.newCampaign;
      
      createCampaign(params)
        .then((result) => {
          // TODO: Redirect to details
          this.$toast.success({
            title: "Sucesso",
            message: "Campanha criada com sucesso",
          });

          this.$router.push({ name: 'CampaignEdit', params: { campaign_id: result.id}})

          })
          .catch(() => {
            this.$toast.error({
              title: "Erro",
              message: "Ocorreu algum problema",
            });
          });
    },
    getTags() {
      this.getTags = []
      getTags()
        .then((result) => {
          this.tagsAccount = result.map(r => { return { id: r.id, label: r.name } })
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Falha ao buscar dados'
          })
        })
    },
    getLists() {
      getLists()
        .then((result) => {
          this.listsAccount = result.map(r => { return { id: r.id, label: r.name } })
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Falha ao buscar dados'
          })
        })
    },
    getContacts() {
      let params = {
        page: 1,
        offset: 1,
        tag: this.newCampaign.contact_tag_id,
        list: this.newCampaign.contact_list_id,
        not_tag: this.newCampaign.not_contact_tag_id,
        limite_date: this.newCampaign.limite_date,
        limite_date_before: this.newCampaign.limite_date_before,
      };
      getContacts(params)
        .then((result) => {
          this.totalContacts = result.total
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar total de contatos",
          });
        })
    },
  },
};
</script>

<style lang="scss" scoped>
.contacts {
  padding-left: 8px;
}
.p-8 {
  padding: 0px 8px;
}

textarea {
  border-radius: 5px;
  border: 1px solid #3333;
  padding: 15px;
  max-width: 1030px;
  min-width: 1030px;
  min-height: 200px;
  max-height: 200px;
}

.active {
  background: var(--primary) !important;
  color: #fff !important;
}

.actions {
  padding: 0px 8px;
  * {
    margin-right: 8px;
  }
}
</style>

<style lang="scss">
.mx-datepicker {
  .mx-input-wrapper {
    .mx-input {
      height: 50px;
    }
  }
  // fix icon
  svg {
    margin-top: 10px;
  }
}
</style>
